// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root__2saNh","loading":"Modal_loading__3V8Rq","largeContainer":"Modal_largeContainer__1iRmZ"};